// extracted by css-extract-rspack-plugin
export default {"sectionHeader":"FindingsSection-module__sectionHeader__jj3Uw"};